module.exports = __webpack_public_path__ + "static/img/sport_bg2.3b860d4e.jpg";